/**
 * Blog Types
 */
export const LOAD_BLOG_SUCCESS = 'LOAD_BLOG_SUCCESS'
export const BLOG_LOADING = 'BLOG_LOADING'
